import React, { useEffect, useState } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Modal from '../common/Modal';
import { AddQuestion } from '../common/AddQuestion';
import { QuestionList } from '../common/QuestionList';
import Steps from '../common/Steps';
import { ExamInfo } from '../common/QuestionInfo';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';
import service from '../../apis/service';
import { GET_INITIAL_OPTIONS } from '../../constants/exam';

const useStyle = makeStyles({
  popupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  questionBox: {
    height: '60vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  inputField: {
    width: '97%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  title: { fontWeight: '700', fontSize: '18px' },
  subTitle: { fontWeight: '500', fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' },
});
export function AddExamPopup({ isOpen, setIsOpen, isEdit, fetchCollection }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const collectionInfo = useSelector((state) => state.getCollection.collection);

  const [questions, setquestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isAddQuestion, setIsAddQuestion] = useState(false);
  const [isQEdit, setIsQEdit] = useState(false);

  // add qeustion
  const [journeys, setJourneys] = useState([]);
  const [guides, setGuides] = useState([]);
  const [selectedGuideId, setSelectedGuideId] = useState('');
  const [selectedJId, setSelectedJId] = useState('');
  const [queType, setQueType] = useState('single_select');
  const [queTitle, setQueTitle] = useState('');
  const [options, setOptions] = useState(GET_INITIAL_OPTIONS);
  const [step, setStep] = useState(1);
  const [examInfo, setExamInfo] = useState({
    numberQuestions: '',
    duration: '',
    passingScore: '',
    instruction: '',
    lockPeriod: '',
    startDate: null,
    endDate: null,
    allowSkipJourneys: false,
  });
  const [timeUnit, setTimeUnit] = useState('days');
  const LOCK_TIME_UNITS = ['hours', 'days', 'months', 'years'];

  const getDetails = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(
        apiEndpoints.COLLECTION_QUESTIONS.replace('ID', collectionInfo.id).replace('TYPE', 'post_assessment'),
      );
      const info = {
        numberQuestions: res.numberQuestions,
        duration: res.duration,
        passingScore: res.passingScore,
        instruction: res.instructions,
        startDate: res.startDate || null,
        endDate: res.endDate || null,
        allowSkipJourneys: res.allowSkipJourneys,
      };
      if (res.lockTime) {
        const parts = res.lockTime.split(' ');
        // eslint-disable-next-line prefer-destructuring
        info.lockPeriod = parts[0];
        let unit = parts[1];
        // eslint-disable-next-line eqeqeq
        if (parts[0] == '1') {
          unit = `${parts[1]}s`;
        }
        setTimeUnit(unit);
      }
      setExamInfo(info);
      setquestions(res.questions || []);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (isEdit && collectionInfo.id) {
      getDetails();
    }
  }, [collectionInfo]);

  const getJourneys = async () => {
    dispatch(showProgress(true));
    try {
      const result = await service.get(apiEndpoints.COLLECTION_JOURNEYS.replace('ID', collectionInfo.id));
      setJourneys(result || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (collectionInfo?.id) {
      getJourneys();
    }
  }, [collectionInfo]);

  useEffect(() => {
    if (selectedJId) {
      const selectedJ = journeys.filter((j) => j.id === selectedJId)[0];
      const guideList = selectedJ ? selectedJ.guides || [] : [];
      setGuides(guideList);
    }
  }, [selectedJId]);

  const isDecimal = (value) => typeof value === 'string' && value.includes('.');

  const handleCreateExam = async () => {
    dispatch(showProgress(true));
    const payload = {
      collectionId: collectionInfo.id,
      numberQuestions: examInfo.numberQuestions,
      examType: 'post_assessment',
      passingScore: examInfo.passingScore,
      instructions: examInfo.instruction,
      startDate: moment(examInfo.startDate).format('YYYY-MM-DD'),
      endDate: moment(examInfo.endDate).format('YYYY-MM-DD'),
      duration: examInfo.duration,
      questions,
      allowSkipJourneys: examInfo.allowSkipJourneys,
    };
    if (examInfo.lockPeriod) {
      let temp = timeUnit;
      // eslint-disable-next-line eqeqeq
      if (examInfo.lockPeriod == '1' && timeUnit.endsWith('s')) {
        temp = timeUnit.slice(0, -1);
      }
      payload.lockTime = `${examInfo.lockPeriod} ${temp}`;
    }

    try {
      await service.post(apiEndpoints.COLLECTION_ASSESMENT, payload);
      notifySuccess('Exam created successfully');
      fetchCollection();
      setIsOpen(false);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  const handleEditExam = async () => {
    dispatch(showProgress(true));
    const payload = {
      examId: collectionInfo.postAssessmentId,
      collectionId: collectionInfo.id,
      numberQuestions: examInfo.numberQuestions,
      examType: 'post_assessment',
      passingScore: examInfo.passingScore,
      instructions: examInfo.instruction,
      startDate: moment(examInfo.startDate).format('YYYY-MM-DD'),
      endDate: moment(examInfo.endDate).format('YYYY-MM-DD'),
      duration: examInfo.duration,
      questions,
      allowSkipJourneys: examInfo.allowSkipJourneys,
    };
    if (examInfo.lockPeriod) {
      let temp = timeUnit;
      // eslint-disable-next-line eqeqeq
      if (examInfo.lockPeriod == '1' && timeUnit.endsWith('s')) {
        temp = timeUnit.slice(0, -1);
      }
      payload.lockTime = `${examInfo.lockPeriod} ${temp}`;
    }

    try {
      await service.post(apiEndpoints.COLLECTION_ASSESMENT_UPDATE, payload);
      notifySuccess('Exam updated successfully');
      fetchCollection();
      setIsOpen(false);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  const getCategorizedQuestions = () => {
    const allQeustions = [...questions];
    const temp = [];
    if (allQeustions && allQeustions.length > 0) {
      allQeustions.forEach((question, indx) => {
        const journeyIndx = temp.findIndex((item) => item.category === question.journeyId);

        if (journeyIndx !== -1) {
          const que = { ...question };
          que.index = indx;
          temp[journeyIndx].questions.push(que);
        } else {
          const que = { ...question };
          que.index = indx;
          temp.push({
            category: question.journeyId,
            questions: [que],
          });
        }
      });
    }
    return temp;
  };

  const handleValidation = () => {
    const errors = [];
    let isValid = true;

    if (step === 1) {
      if (!examInfo.numberQuestions) {
        isValid = false;
        errors.push('Please enter total questions');
      }
      if (examInfo.numberQuestions && examInfo.numberQuestions <= 0) {
        isValid = false;
        errors.push('Total questions must be greater than or equal to 1');
      }

      if (!examInfo.duration) {
        isValid = false;
        errors.push('Please enter a duraion');
      }
      if (examInfo.duration && examInfo.duration <= 0) {
        isValid = false;
        errors.push('Duration must be greater than or equal to 1');
      }
      if (!examInfo.passingScore) {
        isValid = false;
        errors.push('Please enter passing score');
      }
      if (examInfo.passingScore && examInfo.passingScore > 100) {
        isValid = false;
        errors.push('Passing Score must be less than or equal to 100');
      }
      if (examInfo.passingScore && examInfo.passingScore <= 0) {
        isValid = false;
        errors.push('Passing Score must be greater than or equal to 1');
      }
      if (!examInfo.instruction || examInfo.instruction.trim() === '') {
        isValid = false;
        errors.push('Please enter instruction');
      }
      if (isDecimal(examInfo.lockPeriod)) {
        isValid = false;
        errors.push('Please enter valid lock period');
      }
      if (!examInfo.startDate) {
        isValid = false;
        errors.push('Please select start date');
      }
      if (!examInfo.endDate) {
        isValid = false;
        errors.push('Please select end date');
      }
      if (examInfo.startDate && examInfo.endDate && examInfo.endDate < examInfo.startDate) {
        isValid = false;
        errors.push('End date must be greater than start date');
      }
    }

    if (step === 2) {
      if (examInfo.numberQuestions > questions.length) {
        isValid = false;
        errors.push('Please add more questions to meet the exam requirements');
      }

      const categorizedQues = getCategorizedQuestions();
      if (categorizedQues?.length < journeys?.length) {
        isValid = false;
        errors.push('Please add at least 1 question from each journey');
      }
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isValid;
  };

  const checkValidation = () => {
    const errors = [];
    let isValid = true;

    if (!selectedJId) {
      isValid = false;
      errors.push('Please select a journey');
    }

    if (!queTitle || queTitle.trim() === '') {
      isValid = false;
      errors.push('Please enter a question');
    }

    const emptyOptions = options?.filter((op) => !op.title || op.title.trim() === '') || [];
    if (emptyOptions?.length > 0) {
      isValid = false;
      errors.push('Please enter all the options');
    }

    const answerOptions = options?.filter((op) => op.isAnswer) || [];
    if (answerOptions?.length === 0 && queType === 'single_select') {
      isValid = false;
      errors.push('Please select correct option for the question');
    }
    if (answerOptions?.length < 2 && queType === 'multi_select') {
      isValid = false;
      errors.push('Please select atleast two correct options for the question or change the question type');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isValid;
  };

  const onNext = () => {
    if (!handleValidation()) return;
    if (step < 2) {
      setStep((pre) => pre + 1);
    }

    if (step === 2) {
      if (isEdit) {
        handleEditExam();
      } else {
        handleCreateExam();
      }
    }
  };

  const onBack = () => {
    if (step === 2 && isAddQuestion) {
      setIsAddQuestion(false);
      clearState();
    } else {
      setStep((pre) => pre - 1);
    }
  };

  const clearState = () => {
    setSelectedGuideId('');
    setSelectedJId('');
    setQueTitle('');
    setQueType('single_select');
    setOptions(GET_INITIAL_OPTIONS);
    setSelectedIndex(null);
    setIsQEdit(false);
  };

  const onAdd = () => {
    if (!checkValidation()) return;
    const temp = [...questions];
    const que = {
      title: queTitle,
      journeyId: selectedJId,
      type: queType,
      options,
    };
    if (selectedGuideId) {
      que.guideId = selectedGuideId;
    }
    if (isQEdit) {
      const editedQuestion = temp[selectedIndex];
      if (editedQuestion.id && editedQuestion.type === queType) {
        que.id = editedQuestion.id;
      }
      temp[selectedIndex] = que;
      setquestions(temp);
    } else {
      setquestions([...temp, que]);
    }

    clearState();
    setIsAddQuestion(false);
  };

  return (
    <Modal isOpen={isOpen} height="84vh" width="950px">
      <Grid className={classes.popupContainer}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid container direction="column" spacing={1}>
              <Grid item className={classes.title}>
                {isEdit ? 'Edit Exam' : 'Add Exam'}
              </Grid>
              <Grid item className={classes.subTitle}>
                {isEdit ? `ID: ${collectionInfo.postAssessmentId}` : ''}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Steps step={step} stepInfo={['Exam Info', 'Questions']} />

        {step === 1 && (
          <ExamInfo
            examInfo={examInfo}
            setExamInfo={setExamInfo}
            calledFrom="collection"
            LOCK_TIME_UNITS={LOCK_TIME_UNITS}
            setTimeUnit={setTimeUnit}
            timeUnit={timeUnit}
          />
        )}

        {step === 2 && isAddQuestion && (
          <AddQuestion
            journeys={journeys}
            guides={guides}
            setSelectedGuideId={setSelectedGuideId}
            setSelectedJId={setSelectedJId}
            selectedJId={selectedJId}
            selectedGuideId={selectedGuideId}
            setIsAddQuestion={setIsAddQuestion}
            queType={queType}
            setQueType={setQueType}
            queTitle={queTitle}
            setQueTitle={setQueTitle}
            options={options}
            setOptions={setOptions}
            isEdit={isQEdit}
            questions={questions}
            selectedIndex={selectedIndex}
            calledFrom="collection"
          />
        )}

        {step === 2 && !isAddQuestion && (
          <QuestionList
            setIsAddQuestion={setIsAddQuestion}
            questions={questions}
            setQeustions={setquestions}
            setIsEdit={setIsQEdit}
            setSelectedIndex={setSelectedIndex}
            calledFrom="collectionExam"
            journeys={journeys}
            //   remove
            selectedIndex={selectedIndex}
            isQEdit={isQEdit}
          />
        )}

        <Grid style={{ display: 'flex' }}>
          {step > 1 && (
            <Button onClick={onBack} variant="outlined">
              Back
            </Button>
          )}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <>
              <Button onClick={() => setIsOpen(false)} variant="outlined">
                Cancel
              </Button>
              {step === 2 && isAddQuestion ? (
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onAdd}>
                  Add
                </Button>
              ) : (
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onNext}>
                  {step !== 2 ? 'Next' : 'Save'}
                </Button>
              )}
            </>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
